<template>
  <div>
    <page-title
      subtitle="Edit Coverage"
      :showSaveDraft="false"
      :cancelRoute="cancelRoute"
    />
    <coverages-list
      title="Edit Coverage"
      :showAddLink="true"
      :member="computedMember"
      :coverageHistory="computedCoverageHistory"
      />
  </div>
</template>

<script>
  import CoveragesList from './Shared/CoveragesList'
  import PageTitle from '../MemberEdit/PageTitle'
  import CoverageHelper from '@mixins/CoverageHelper'

  export default {
    mixins: [CoverageHelper],
    components: {
      CoveragesList,
      PageTitle
    }
  }
</script>
